import { v4 } from 'uuid'

const getValidityToken = () => {
  if (!localStorage.getItem('vt')) {
    localStorage.setItem('vt', v4())
  }
  return localStorage.getItem('vt')
}

export { getValidityToken }



// WEBPACK FOOTER //
// ./src/utils/tools.js